import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../styling/Dashboard.css";

const GetStartedPanel = ({ setSelectedMenuItem }) => {
  const navigate = useNavigate();
  const [isStripeLoading, setIsStripeLoading] = useState(false);

  const boxStyle = {
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: '1px solid #D9D9D9',
    borderRadius: '3px',
    padding: '10px',
    marginBottom: '15px',
    cursor: 'pointer'
  };

  // --- NEW: Function to handle the Stripe Redirect ---
  const handleStripeOnboarding = async () => {
    setIsStripeLoading(true);
    try {
      // NOTE: Ensure this URL matches whatever route you set up in your backend!
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business-user/stripe-onboarding`, 
        { withCredentials: true }
      );
      
      // Redirect the user instantly to the Stripe hosted form
      window.location.href = response.data.data.url;
    } catch (error) {
      console.error("Failed to get Stripe onboarding link:", error);
      alert("Could not load Stripe onboarding. Please try again.");
      setIsStripeLoading(false);
    }
  };

  return (
    <div className="get-started-booking-container" style={{ padding: '0px' }}>
      <div className="get-started-sidebar" style={{
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        padding: '10px 20px',
        boxShadow: '0px 2px 4px #15223214',
        borderRadius: '3px',
        marginBottom: '25px'
      }}>
        <h2 style={{ fontSize: '20px' }}> Get Started </h2>

        <div style={boxStyle} onClick={() => setSelectedMenuItem("company")}>
          <p style={{ fontSize: '15px', fontWeight: 'bold' }}> 
            <span className="sidebar-list-item" style={{ background: '#F2F2F2', padding: '5px 15px', borderRadius: '50px' }}>1</span> 
            Add Company Branding 
          </p>
          <p style={{ fontSize: '15px', color: '#625C73' }}> Customize your brand colors and add brand logo</p>
        </div>

        {/* --- UPDATED STRIPE BUTTON --- */}
        <div style={{ ...boxStyle, opacity: isStripeLoading ? 0.6 : 1 }} onClick={!isStripeLoading ? handleStripeOnboarding : null}>
          <p style={{ fontSize: '15px', fontWeight: 'bold' }}> 
            <span className="sidebar-list-item" style={{ background: '#F2F2F2', padding: '5px 15px', borderRadius: '50px' }}>2</span> 
            {isStripeLoading ? "Loading Stripe..." : "Setup Payouts (Stripe)"} 
          </p>
          <p style={{ fontSize: '15px', color: '#625C73' }}> Connect your bank account to receive payments</p>
        </div>

        <div style={boxStyle} onClick={() => setSelectedMenuItem("booth")}>
          <p style={{ fontSize: '15px', fontWeight: 'bold' }}> 
            <span className="sidebar-list-item" style={{ background: '#F2F2F2', padding: '5px 15px', borderRadius: '50px' }}>3</span> 
            Add Package Pricing 
          </p>
          <p style={{ fontSize: '15px', color: '#625C73' }}> Create packages for your clients to book</p>
        </div>

        <div style={boxStyle} onClick={() => setSelectedMenuItem("booth")}>
          <p style={{ fontSize: '15px', fontWeight: 'bold' }}> 
            <span className="sidebar-list-item" style={{ background: '#F2F2F2', padding: '5px 15px', borderRadius: '50px' }}>4</span> 
            Share Client Login 
          </p>
          <p style={{ fontSize: '15px', color: '#625C73' }}> Give clients access to their portal</p>
        </div>

        <div style={boxStyle} onClick={() => setSelectedMenuItem("booth")}>
          <p style={{ fontSize: '15px', fontWeight: 'bold' }}> 
            <span className="sidebar-list-item" style={{ background: '#F2F2F2', padding: '5px 15px', borderRadius: '50px' }}>5</span> 
            Share Book-A-Booth Link 
          </p>
          <p style={{ fontSize: '15px', color: '#625C73' }}> Send your public booking page to leads</p>
        </div>

      </div>

      <div className="new-bookings-sidebar-block" style={{
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        padding: '10px 20px 20px',
        boxShadow: '0px 2px 4px #15223214',
        borderRadius: '3px',
      }}>
        <h2 style={{ fontSize: '20px' }}> New Bookings </h2>
        <div style={boxStyle}>
          <p style={{ fontSize: '15px', color: '#625C73' }}> Once you book your first event this widget will populate </p>
        </div>
        <button style={{ background: 'transparent linear-gradient(90deg, #1C1154 0%, #260F99 100%) 0% 0% no-repeat padding-box', border: 'none', padding: '10px', width: '100%', borderRadius: '3px', color: '#fff', fontSize: '15px', cursor: 'pointer' }}> View All </button>
      </div>
    </div>
  );
};

export default GetStartedPanel;